/**
 * Rewrites Supabase Storage public object URLs to the image-render endpoint so
 * covers are delivered resized (and in a modern format) instead of as multi-MB PNGs.
 * Non-Supabase URLs and local paths pass through unchanged.
 */

const OBJECT_PATH = '/storage/v1/object/public/';
const RENDER_PATH = '/storage/v1/render/image/public/';

export const optimizedImage = (
  url: string | null | undefined,
  width = 600,
  quality = 70
): string => {
  if (!url) return '';
  if (!url.includes(OBJECT_PATH)) return url;

  const [base, existingQuery] = url.split('?');
  const rendered = base.replace(OBJECT_PATH, RENDER_PATH);
  const params = new URLSearchParams(existingQuery);
  params.set('width', String(width));
  params.set('quality', String(quality));
  params.set('resize', 'cover');
  return `${rendered}?${params.toString()}`;
};

/** Two-density srcSet for square cards. */
export const optimizedSrcSet = (
  url: string | null | undefined,
  widths: number[] = [400, 800]
): string | undefined => {
  if (!url || !url.includes(OBJECT_PATH)) return undefined;
  return widths.map((w) => `${optimizedImage(url, w)} ${w}w`).join(', ');
};

export const CARD_SIZES = '(max-width: 768px) 90vw, (max-width: 1280px) 45vw, 320px';
